module.exports = __webpack_public_path__ + "static/media/tw.3c944f89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tw.svg
// module id = 273
// module chunks = 0